import React from 'react';
import PageLayout from '../../components/PageLayout';
import BotForm from '../../components/bots/BotForm'; // Import the BotForm component

const CreateBotPage = () => {
  // onSuccess callback can be passed to BotForm if specific actions are needed after creation,
  // otherwise BotForm handles navigation by default.
  return (
    <PageLayout
      title="Create New Bot Group"
      backButton={{ label: 'Back to Bots', to: '/bots', preferHistory: false, hideLabelOnMobile: true }}
    >
      <BotForm />
    </PageLayout>
  );
};

export default CreateBotPage;
